/* Copyright (c) 2020 Business News Americas Limitada - All Rights Reserved Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential */
import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import NavBar from './root.component.js';

/* * Call the component to display */
export const navBar = singleSpaReact({React, ReactDOM, rootComponent: NavBar, suppressComponentDidCatchWarning: true, domElementGetter});

function domElementGetter() {
  return document.getElementById("navBar")
}
